// src/context/PortalAuthContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import portalApi, { portalTokenKey } from '../utils/portalApi';

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMember = useCallback(async () => {
    const token = localStorage.getItem(portalTokenKey);
    if (!token) { setMember(null); setLoading(false); return; }
    try {
      const res = await portalApi.get('/auth/member/me');
      setMember(res.data);
    } catch (_) {
      setMember(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadMember(); }, [loadMember]);

  const login = async (email, password) => {
    const res = await portalApi.post('/auth/member/login', { email, password });
    localStorage.setItem(portalTokenKey, res.data.accessToken);
    setMember(res.data.member);
    return res.data.member;
  };

  const logout = async () => {
    try { await portalApi.post('/auth/member/logout'); } catch (_) {}
    localStorage.removeItem(portalTokenKey);
    setMember(null);
  };

  const isAdmin = () => member?.portalRole === 'member_admin';

  return (
    <PortalAuthContext.Provider value={{ member, loading, login, logout, isAdmin, loadMember }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export function usePortalAuth() {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error('usePortalAuth must be used within PortalAuthProvider');
  return ctx;
}
